import {Sound} from '@pixi/sound';
import {SoundProperties, SoundsProperties} from '@gongxigames/framework/slot/types/SoundProperties';

export interface ISoundTool {
    sounds: Map<string, Sound>;
    replaceSounds: (sounds: Map<string, Sound>) => void;
    playSound: (name: string) => void;
    stopSound: (name: string) => void;
    editSound: <P extends keyof SoundProperties>(name: string, property: P, value: SoundProperties[P]) => void;
    stopAllSounds: () => void;
    soundsProperties: SoundsProperties;
    getSoundConfig(name: string): SoundProperties;
}
